<template>
  <Instance
    instance="userActivityLog"
    instance-name="User Activity Log"
    :get="d => userActivityLog.get(d)"
    :columns="columns"
    :initFilter="filter"
    :showActions="false"
    :showDateFilter="true"
  />
</template>

<script>
import moment from 'moment';
import Instance from '../../CRUD/instance';
import { USER_ACTIVITY_BASE_TYPES } from '../../../../../../../constants';
import api from '../../../api';

export default {
  title: 'Suppliers',
  components: { Instance },
  data() {
    return {
      userActivityLog: api.userActivityLog,
      filter: {
        page: 1,
        limit: 30,
        totalCount: 0,
        sortBy: 'createdAt',
        sortOrder: 'desc',
        searchQuery: ''
      }
    };
  },
  methods: {
    renderObjectString(o) {
      const deleteProps = ['__v', 'createdAt', 'updatedAt'];
      deleteProps.forEach(i => {
        delete o[i];
      });
      const str = [];
      Object.keys(o).map(key => {
        str.push(`${key}: ${JSON.stringify(o[key])}`);
      });
      return str.join(' , ');
    },
    renderState(oldState, newState, type, isOldPlace) {
      switch (type) {
        case USER_ACTIVITY_BASE_TYPES.CREATE:
          return isOldPlace ? '-' : this.renderObjectString(newState);
        case USER_ACTIVITY_BASE_TYPES.CREATE_AUTOMATICALLY:
          return isOldPlace ? '-' : this.renderObjectString(newState);
        case USER_ACTIVITY_BASE_TYPES.DELETE:
          return isOldPlace ? oldState.data.map(i => this.renderObjectString(i)) : '-';
        case USER_ACTIVITY_BASE_TYPES.UPDATE:
          return isOldPlace ? this.renderObjectString(oldState) : this.renderObjectString(newState);
        case USER_ACTIVITY_BASE_TYPES.UPDATE_PASSWORD:
          return '-';
      }
    },
    columns() {
      return [
        {
          field: 'createdAt',
          title: this.$translate('Date'),
          key: '1',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return moment
              .utc(row.createdAt)
              .local()
              .format('DD.MM.YYYY HH:mm:ss');
          }
        },
        {
          field: 'user',
          title: this.$translate('User'),
          key: '2',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return row.user ? (row.user.email ? row.user.email : row.user.name) : '-';
          }
        },
        {
          field: 'Place',
          title: this.$translate('Place'),
          key: '3',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return this.$translate(row.entity);
          }
        },
        {
          field: 'Action',
          title: this.$translate('Action'),
          key: '4',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return this.$translate(row.type);
          }
        },
        {
          field: 'Entity',
          title: this.$translate('Entity'),
          key: '44',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row: { oldState, newState, diff, type } }) => {
            const obj = oldState || newState || {};

            let changes = [];
            let added = [];
            let deleted = [];

            const isCreated = type === USER_ACTIVITY_BASE_TYPES.CREATE || type === USER_ACTIVITY_BASE_TYPES.CREATE_AUTOMATICALLY;
            const isDeleted = type === USER_ACTIVITY_BASE_TYPES.DELETE;

            if (type === USER_ACTIVITY_BASE_TYPES.UPDATE) {
              changes = diff.filter(v => v.action === 'change');
              added = diff.filter(v => v.action === 'add');
              deleted = diff.filter(v => v.action === 'delete');
            }

            const getValue = o => {
              const str = [];
              if (o) {
                if (o._id || o.id) {
                  str.push(`ID: ${o._id || o.id}`);
                }
                if (o.name) {
                  str.push(`Name: ${o.name}`);
                }
                if (o.username) {
                  str.push(`User name: ${o.username}`);
                }
              }
              return str.length ? str.join(' | ') : '-';
            };

            const green = '#28a745';
            const red = '#dc3545';
            const black = '#000000d9';
            const getMainInfo = (obj = {}, addBr = false) => {
              return (
                <div>
                  {(obj._id || obj.id) && (
                    <span>
                      {this.$translate('ID')}: {obj._id || obj.id}
                      <br />
                    </span>
                  )}
                  {obj.name && (
                    <span>
                      {this.$translate('Name')}: {obj.name}
                      <br />
                    </span>
                  )}
                  {obj.username && (
                    <span>
                      {this.$translate('User name')}: {obj.username}
                      <br />
                    </span>
                  )}
                  {addBr && <br />}
                </div>
              );
            };

            const mainColor = isCreated ? green : isDeleted ? red : black;
            return (
              <div style={`color:${mainColor}`}>
                {obj ? (obj.data ? obj.data.map((o, index) => getMainInfo(o, index !== obj.data.length - 1)) : getMainInfo(obj)) : ''}
                {changes.map(v => (
                  <span>
                    {v.deep} → <span style={`color: ${red};`}>{this.$translate(v.old) || '-'}</span> →{' '}
                    <span style={`color: ${green};`}>{this.$translate(v.new) || '-'}</span>
                    <br />
                  </span>
                ))}
                {added.map(v => (
                  <span>
                    {v.deep} → <span style={`color: ${green};`}>{getValue(v.new) || '-'}</span>
                    <br />
                  </span>
                ))}
                {deleted.map(v => (
                  <span>
                    {v.deep} → <span style={`color: ${red};`}>{getValue(v.old) || '-'}</span>
                    <br />
                  </span>
                ))}
              </div>
            );
          }
        }
        // {
        //   field: 'Old version',
        //   title: this.$translate('Old version'),
        //   key: '5',
        //   sortBy: '',
        //   align: 'left',
        //   renderBodyCell: ({ row: { oldState, newState, type } }) => {
        //     return this.renderState(oldState, newState, type, true);
        //   }
        // },
        // {
        //   field: 'New version',
        //   title: this.$translate('New version'),
        //   key: '6',
        //   sortBy: '',
        //   align: 'left',
        //   renderBodyCell: ({ row: { oldState, newState, type } }) => {
        //     return this.renderState(oldState, newState, type, false);
        //   }
        // }
      ];
    }
  }
};
</script>
